module.exports = __webpack_public_path__ + "static/media/17UN-Women8.e166a2d7.jpg";